export default function makeEntriesRows (context) {
  return context.data.journalsData
}
